import useRequest from '@/websdk/utils/request';

export default (function () {
  // console.error('GET==>', isContinue)
  const { isRequestSuccessed, data, exec } = useRequest({
    url: `/api/maintain/moldspotcheck`,
    name: 'MOLD_SPOTCHECK_GET',
    method: 'GET',
  });
  return [isRequestSuccessed, data || [], exec];
});
